import { useBatchSkiptraceStore } from 'features/BatchSkiptrace/infra/views/BatchSkiptraceStore/BatchSkiptraceStoreLive'

export const useGetBatchSkiptraceStatsByListIdState = () =>
  useBatchSkiptraceStore(store => store.getStatsByListId.state)
